import { number } from './basler-components.es805.js';

const int = {
    ...number,
    transform: Math.round,
};

export { int };
